export const plates = [
  {
    src: "home.webp",
    thumb: "home-thumb.webp",
    caption: "Fig. 01 — Homepage",
    alt: "Homepage built as a custom page",
    href: "https://reset-type.com",
  },
  {
    src: "home-tester.webp",
    thumb: "home-tester-thumb.webp",
    caption: "Fig. 02 — Live Tester",
    alt: "Visitors tune size, width, weight and OpenType features before buying",
    href: "https://reset-type.com",
  },
  {
    src: "buying-options.webp",
    thumb: "buying-options-thumb.webp",
    caption: "Fig. 03 — Licensing",
    alt: "Whole family or single styles — the buyer decides",
    href: "https://reset-type.com/typeface/Libertad",
  },
  {
    src: "cart.webp",
    thumb: "cart-thumb.webp",
    caption: "Fig. 04 — Checkout",
    alt: "Coupons and PayPal checkout; you receive the full price",
  },
  {
    src: "journal.webp",
    thumb: "journal-thumb.webp",
    caption: "Fig. 05 — Journal",
    alt: "Long-form articles for your community",
    href: "https://reset-type.com/journal",
  },
  {
    src: "journal-post.webp",
    thumb: "journal-post-thumb.webp",
    caption: "Fig. 06 — Journal Post",
    alt: "Each article gets its own byline, date and full-width specimen",
    href: "https://reset-type.com/journal/RST-Resolut-an-act-of-revival",
  },
  {
    src: "admin-home.webp",
    thumb: "admin-home-thumb.webp",
    caption: "Fig. 07 — Admin: Homepage",
    alt: "Drag-and-drop blocks build the homepage, no code required",
  },
  {
    src: "admin-variants.webp",
    thumb: "admin-variants-thumb.webp",
    caption: "Fig. 08 — Admin: Typefaces",
    alt: "Every style, axis and price managed from the typeface editor",
  },
  {
    src: "admin-cm.webp",
    thumb: "admin-cm-thumb.webp",
    caption: "Fig. 09 — Admin: Media",
    alt: "A shared media library for every image and file across the site",
  },
];
